export { default } from './EzEntityInfo.vue';
